// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".addContacts[data-v-04cef68b]  .el-dialog{padding:10px}.red[data-v-04cef68b]{color:red}.labelBox[data-v-04cef68b]{font-size:14px;color:#666}.marketingActivitiesName[data-v-04cef68b]{width:100%;height:30px;line-height:30px;border:1px solid #e3e2e2;border-radius:3px}[data-v-04cef68b] .el-tabs__item{font-size:15px}[data-v-04cef68b] .el-select .el-input__inner{height:30px;line-height:30px}[data-v-04cef68b] .el-input__icon{line-height:30px}", ""]);
// Exports
module.exports = exports;
